// components/Layout/MainLayout.js
import React from 'react';
import Menu from '../Menu/Menu';
import { Outlet } from 'react-router-dom'; //Import Outlet
import '../../styles/styles.css';

const MainLayout = ({ children }) => {
  return (
    <div className="main-container">
      <Menu />
      <div className="content-container">
        <Outlet /> {/* Place Outlet here */}
      </div>
    </div>
  );
};

export default MainLayout;